
import "./VirtualClassL.css"
import img1 from "../../Images/UNSMoodleLogin.png"
import img2 from "../../Images/UNSMyCourses.png"
import img3 from "../../Images/UNSEditMode.png"
import img4 from "../../Images/UNSAddResource.png"
import img5 from "../../Images/UNSMeetMoodle.png"
import img6 from "../../Images/UNSRoomD1.png"
import img7 from "../../Images/UNSRoomD2.png"
import img8 from "../../Images/ActivityGen2.png"
import img9 from "../../Images/EditActivity2.png"
import img11 from "../../Images/EditActivity.png"
import img10 from "../../Images/SaveActivity.png"
import img12 from "../../Images/DeleteActivity.png"

// import { Outlet } from "react-router-dom";


function VirtualClassL() {
    return (
      <div className="lecturerCover"> 

            <h1>Virtual Classes</h1>
              <div className="ContentOutput">
                    <div className="Hyperlinks">
                        <ul>
                             <li><a href="#Section1">Introduction to moodle</a>  </li>
                             <li><a href="#Section2">How to create a class</a>  </li>
                             <li><a href="#Section3">How to edit class details</a> </li>
                             <li><a href="#Section4">How to delete a class</a> </li>
                             <li><a href="#Section2">How to a add Resources</a> </li>
                        </ul>

                    </div>
                    <div className="resourceSection">
                      
                          <section id="Section1">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h3>Introduction to Moodle</h3>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                          Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                      </p>    
                                                      <p> 
                                                        Almost all taught modules have a Moodle space.

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  

                                     </div>


                                </div>
   

                          </section>
                          <section id="Section2">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h2>How to create a class</h2>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                         <b> STEP 1 :</b> Navigate to My courses
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img2} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                      <b>
                                                          STEP 2 : </b>Enable edit mode
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img3} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                   <p> 
                                                         <b>STEP 3 :</b> Ensure your google account(email) is logged on/synced with the platform
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img1} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                    <p> 
                                                         <b>STEP 4 :</b> Click on add activity or resource
                                                      </p>    
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img4} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                    <p> 
                                                         <b>STEP 5 :</b>  Navigate to google meet for moodle 
                                                      </p>   
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img5} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                    <p> 
                                                         <b>STEP 6 :</b>  Fill in the class details as in the illustration
                                                      </p>   
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img6} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                    <p> 
                                                         <b>STEP 7 :</b>  Enter time, date and respective class retrictions (if any) then save the event
                                                      </p>   
                                                      <p> 
                                                        {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img7} />

                                     </div>
                                                  <div className="contentParagraph"> 

                                                    <p> 
                                                         <b>STEP 8 :</b>  Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                      </p>   
                                                      <p> 
                                                        Almost all taught modules have a Moodle space.

                                                      </p>    

                                                </div>
                                      <div className="contentImage">  
                                          <img src={img8} />

                                     </div>


                                </div>
   

                          </section>
                          <section id="Section3">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h2>How to edit class details</h2>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                          
                                                      </p>    

                                                      <p> 
                                                      

                                                      </p>    

                                                </div>
                                                <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 1 :</b>  Navigate to my courses
                                                                  </p>   
                                                                  <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                </div>
                        

                                          <div className="contentImage">  
                                             
                                                <img src={img2} />

                                          </div>
                                                <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 2 :</b>  Enable edit mode mode by toggling the button at the top right corner 
                                                                  </p>   
                                                                  <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                </div>
                        

                                          <div className="contentImage">  
                                             
                                                <img src={img3} />

                                          </div>
                                                <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 3 :</b>  Navigate to the Class (Activity)
                                                                  </p>   
                                                                  <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                </div>
                        

                                          <div className="contentImage">  
                                             
                                                <img src={img8} />

                                          </div>
                                                <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 3 :</b>  Click on stacked dots icons
                                                                  </p>   
                                                                  <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                </div>
                        

                                          <div className="contentImage">  
                                             
                                                <img src={img11} />

                                          </div>
                                                <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 4 :</b>  Scroll through the settings and configurations
                                                                  </p>   
                                                                  <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                </div>
                        

                                          <div className="contentImage">  
                                             
                                                <img src={img9} />

                                          </div>
                                                <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 5 :</b>  Change settings or text by clicking on them then SAVE
                                                                  </p>   
                                                                  <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                </div>
                        

                                          <div className="contentImage">  
                                             
                                                <img src={img10} />

                                          </div>


                                </div>
   

                          </section>
                          <section id="Section4">

                                <div className="contentWhole">  

                                      <div className="contentHeading">  
                                            <h3>How to delete a class</h3>
                                            </div>
                                                  <div className="contentParagraph"> 

                                                      <p> 
                                                          Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                      </p>    
                                                      <p> 
                                                        Almost all taught modules have a Moodle space.

                                                      </p>    

                                                </div>

                                                <div className="contentParagraph"> 

                                                      <p> 
                                                            <b>STEP 1 :</b>  Navigate to the respective class(Activity) 
                                                            </p>   
                                                            <p> 
                                                            {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                                <div className="contentImage">  
                                             
                                                      <img src={img8} />

                                                </div>

                                                <div className="contentParagraph"> 

                                                      <p> 
                                                            <b>STEP 2 :</b>  Click on the three stacked dots icon then Delete 
                                                            </p>   
                                                            <p> 
                                                            {/* Almost all taught modules have a Moodle space. */}

                                                      </p>    

                                                </div>
                                                <div className="contentImage">  
                                             
                                                      <img src={img12} />

                                                </div>
                                                                              


                                </div>
   

                          </section>

                    </div>
                 
              </div>
      
      </div>
    );
  }
  
  export default VirtualClassL;
  